import {Component, OnInit} from '@angular/core';
import {PagesHttpService} from '../../../services/http-services/pages/pages-http.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html'
})
export class AboutUsComponent implements OnInit {
  gallery: any;
  showCarousel = false;
  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000
  };

  constructor(private pagesHttpService: PagesHttpService) { }

  ngOnInit(): void {
    this.getAboutUsGallery();
  }

  getAboutUsGallery(): void {
    this.pagesHttpService.getAboutUsGalleryLanding().then(response => {
      this.gallery = response.data?.images;
    });
  }

  handleShowCarousel(imageIndex: number): void {
    this.slideConfig.initialSlide = imageIndex;
    this.showCarousel = true;
  }
}
